import { useState } from 'react';
import { INITIAL_PAGE, LIMIT } from 'utilities/constants';

function usePaginateDefaults() {
  const [params, setParams] = useState({ page: INITIAL_PAGE, limit: LIMIT });

  return [params, setParams];
}

export default usePaginateDefaults;
